import React from 'react';
import SimpleBorderedCard from '@components/subscription/detail/micro/SimpleBorderedCard';
import SubscribeHintButton from '@components/subscription/detail/hint/button/SubscribeHintButton';
import { useAtomValue } from 'jotai';
import {
  isHintSubsRecurringAtom,
  shouldSubscribeHintAtom,
} from '@components/subscription/store/HintPaymentAtoms';
import CancelHintButton from '@components/subscription/detail/hint/button/CancelHintButton';
import ReactivateHintButton from '@components/subscription/detail/hint/button/ReactivateHintButton';
import HintPaymentCardContent from '@components/subscription/detail/hint/HintPaymentCardContent';
import LightBulb from '@assets/icons/light-bulb';
import { subjectSubscriptionAtom } from '@components/subscription/store/SubscriptionAtoms';
import ContactSupportButton from '@components/subscription/detail/hint/button/ContactSupportButton';

const HintPaymentCard = () => {
  const isRecurring = useAtomValue(isHintSubsRecurringAtom);
  const shouldSubscribe = useAtomValue(shouldSubscribeHintAtom);
  const parentSubs = useAtomValue(subjectSubscriptionAtom);

  const isParentSubsRecurring = parentSubs?.auto_renewal;

  return (
    <SimpleBorderedCard
      title={
        <>
          <LightBulb
            className={
              'fill-current text-neutral-chalk w-3.5 inline ml-3 mr-2 align-baseline'
            }
          />
          <p className={'inline text-sm font-bold leading-5 mr-2'}>Hints</p>
          <div
            className={'rounded-full bg-neutral-chalk px-2 py-0.5 inline-block'}
          >
            <p
              className={
                'text-sm font-bold leading-5 bg-gradient-to-r from-[#018BC4] to-[#8F4690] bg-clip-text text-transparent'
              }
            >
              New!
            </p>
          </div>
        </>
      }
    >
      <div className={'mb-4'}>
        <div className={'mb-4'}>
          <p className={'font-bold text-[34px] leading-[1.2]'}>
            {!shouldSubscribe ? 'Unlimited' : 0}
          </p>
          <p className={'font-bold !leading-5 max-lg:text-sm'}>Available</p>
        </div>
        <div
          className={
            'text-neutral-pencil lg:!leading-[19px] lg:text-sm max-lg:!leading-4 max-lg:text-xs'
          }
        >
          <HintPaymentCardContent />
        </div>
      </div>
      <div className={'mt-auto'}>
        {shouldSubscribe ? (
          <SubscribeHintButton />
        ) : !isParentSubsRecurring ? (
          <ContactSupportButton />
        ) : isRecurring ? (
          <CancelHintButton />
        ) : (
          <ReactivateHintButton />
        )}
      </div>
    </SimpleBorderedCard>
  );
};

export default HintPaymentCard;
